import type { AppDispatch } from "redux/store";

import {
    FEED_OPTIONS_DATA_ERROR,
    FEED_OPTIONS_DATA_LOADING,
    GET_ALL_FEEDS_DATA,
    SET_ALL_FEEDS_DATA,
    SET_ALL_FEEDS_DATA_ERROR,
    SET_ALL_FEEDS_DATA_LOADING,
    SET_FEED_OPTIONS_DATA,
    SET_IS_NEED_UPDATE_DATA
} from "./constants";
import { feedService } from "api";
import type { IAllFeedOptionsData } from "api/services/feed/types";
import { IFormFeedData } from "./types";
import { setTemporaryNotifications } from "redux/notifications/actions";
import { defaultNotificationCreator } from "templates/Notifications";
import { feedFormsDataAdapter } from "./adapters";

export const getFeedOptionsData = (sellerId: number) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setFeedOptionsDataLoading(true));

        const res = await feedService.getAllFeedOptions(sellerId);

        res.data.data.formats = res.data.data.formats.map((item) =>
            item.name === 'Common'
                ? { ...item, name: 'Общий (YML)'}
                : item
        );

        const errorInfo = res.data?.errors[0] ? res.data.errors[0] : "some error occured";

        if(res.status > 300) {
            throw new Error(errorInfo);
        }

        if(!res.data.data) {
            throw new Error(errorInfo);
        } 

        dispatch(setFeedOptionsData(res.data.data));

    } catch (error: any) {
        dispatch(setFeedOptionsDataError(error.message))
    } finally {
        dispatch(setFeedOptionsDataLoading(false));
    }

}

export const updateFeedData = (data: IFormFeedData) => async (dispatch: AppDispatch) => {
    try {

        const res = await feedService.updateFeed(data);

        const errorInfo = res?.data?.errors[0]?.message ? res.data.errors[0]?.message : "some error occured";

        if(res.status > 300 || !res.data.data) {
            throw new Error(errorInfo);
        }

        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Фид успешно обновлен",
                description: "Вы успешно обновили фид",
                iconType: "success"
            })
        ))

    } catch (error: any) {
        console.error(error.message);
        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Произошла ошибка при обновлении фида",
                description: "Произошла непредвиденная ошибка, повторите позже",
                iconType: "warning"
            })
        ))
    }
}

export const createPostFeed = (data: IFormFeedData)  => async (dispatch: AppDispatch) =>  {
    try {
        const res = await feedService.addFeed(data);

        const errorInfo = "some error occured";

        if(res.status > 300 || !res.data.data) {
            throw new Error(errorInfo);
        }
        dispatch(setIsNeedUpdateData(true))
    } catch (error) {
        console.error(error);
        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Произошла ошибка при добавлении фида",
                description: "Произошла непредвиденная ошибка, повторите позже",
                iconType: "warning"
            })
        ))
    }
}

export const setFeedOptionsData = (data: IAllFeedOptionsData) => ({
    type: SET_FEED_OPTIONS_DATA,
    payload: data
})

export const setFeedOptionsDataLoading = (data: boolean) => ({
    type: FEED_OPTIONS_DATA_LOADING,
    payload: data
})

export const setFeedOptionsDataError = (data: string) => ({
    type: FEED_OPTIONS_DATA_ERROR,
    payload: data
})

export const getAllFeedsData = (sellerId: number) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setAllFeedsDataLoading(true));

        const res = await feedService.getAllFeeds(sellerId);

        const errorInfo = res.data?.errors[0]?.message ? res.data.errors[0]?.message : "some error occured";

        if(res.status > 300 || !res.data.data) {
            throw new Error(errorInfo);
        }
        
        const mappedData = feedFormsDataAdapter(res.data.data);

        dispatch(setAllFeedsData(mappedData));
    } catch (error: any) {
        console.error(error.message);
        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Произошла ошибка при получении фидов",
                description: "Произошла непредвиденная ошибка, повторите позже",
                iconType: "warning"
            })
        ))
    } finally {
        dispatch(setAllFeedsDataLoading(false));
    }
}

export const setAllFeedsData = (data: IFormFeedData[]) => ({
    type: SET_ALL_FEEDS_DATA,
    payload: data
})

export const setAllFeedsDataLoading = (data: boolean) => ({
    type: SET_ALL_FEEDS_DATA_LOADING,
    payload: data
})

export const setIsNeedUpdateData = (data: boolean) => ({
    type: SET_IS_NEED_UPDATE_DATA,
    payload: data
})

export const setAllFeedsDataError = (data: string) => ({
    type: SET_ALL_FEEDS_DATA_ERROR,
    payload: data
})

export const deleteFeedForm = (id: number) => async(dispatch: AppDispatch) => {
    try {
        const res = await feedService.deleteFeed(id);

        const errorInfo = res.data?.errors[0] ? res.data.errors[0] : "some error occured";

        if(res.status > 300) {
            throw new Error(errorInfo);
        }

        if(!res.data.data) {
            throw new Error(errorInfo);
        }

        dispatch(setIsNeedUpdateData(true))

        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Фид успешно помещен в архив",
                description: "",
                iconType: "success"
            })
        ))

    } catch (error: any) {
        console.error(error.message);
        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Произошла ошибка при удаления фида",
                description: "Произошла непредвиденная ошибка, повторите позже",
                iconType: "warning"
            })
        ))
    }
}

export const restoreFeedForm = (id: number) => async(dispatch: AppDispatch) => {
    try {
        const res = await feedService.restoreFeed(id);

        const errorInfo = res.data?.errors[0] ? res.data.errors[0] : "some error occured";

        if(res.status > 300) {
            throw new Error(errorInfo);
        }

        if(!res.data.data) {
            throw new Error(errorInfo);
        }

        dispatch(setIsNeedUpdateData(true))

        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Фид успешно восстановлен",
                description: "",
                iconType: "success"
            })
        ))

    } catch (error: any) {
        console.error(error.message);
        dispatch(setTemporaryNotifications(
            defaultNotificationCreator({
                title: "Произошла ошибка при восстановлении фида",
                description: "Произошла непредвиденная ошибка, повторите позже",
                iconType: "warning"
            })
        ))
    }
}